import {
    GETMAPPINGROLELIST_SUCCESS,
    GETMAPPINGROLELIST_FAILED,
    RESET_GETMAPPINGROLELIST,
    LOADING_GETMAPPINGROLELIST,
    NETWORK_ERROR_GETMAPPINGROLELIST,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETMAPPINGROLELIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };
        case GETMAPPINGROLELIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case GETMAPPINGROLELIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case NETWORK_ERROR_GETMAPPINGROLELIST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        case RESET_GETMAPPINGROLELIST:
            return (state = initialState);
        default:
            return state;
    }
};
